import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { MaintenanceWindowGridBaseDataProvider } from './MaintenanceWindowGridBaseDataProvider';

export class MaintenanceWindowGridGzDataProvider extends MaintenanceWindowGridBaseDataProvider {
  /**
   * Remove records
   * @param params
   */
  async removeRecords(params: any): Promise<{ success: boolean }> {
    return this.dependencies.api.clients.MaintenanceWindows.removeRecords({ records: params });
  }
}
